module.exports = __webpack_public_path__ + "static_portal/img/squats.07a5fd21.svg";